<template>
    <CRow class="mt-3">
        <CCol col="12" sm="12" md="10" lg="7" xl="6" class="mx-auto">
            <div class="p-2 b-a-2 bg-white">
                <AffiliScriptSingle />

                <span class="bg-primary w-100 d-block mb-4" style="height:2px"></span>

                <TestScript />

                <CRow>
                    <CCol col="12" class="b-t-1 pt-2 mt-3">
                        <CButton :disabled="!store.test_conversion_data" @click="nxt" type="button" color="primary" class="px-4 float-right">{{ $t('btn.next_step') }}</CButton>
                        <CButton type="button" @click="prev" color="outline-primary" class="px-4">{{ $t('btn.prev_step') }}</CButton>
                    </CCol>
                </CRow>
            </div>
        </CCol>
    </CRow>
</template>

<script>
import { AffiliScriptSingle, TestScript } from './../partials'
import { mapActions, mapGetters } from 'vuex'
import { UserSetupStatus } from '@/constants'

export default {
    name: 'ImplementScript',

    components: {
        AffiliScriptSingle,
        TestScript,
    },

    beforeRouteEnter (to, from, next) {
        next(vm => {
            vm.fetchStores({
                no_paginate: true
            }).then(() => {
                vm.testConversion(vm.store.id).then(result => {
                   vm.implementScript = result.data.amount && result.data.external_id
               })
            })
        })
    },

    data() {
        return {
            implementScript: false,
        }
    },

    computed: {
        ...mapGetters({
            store: 'store/firstStore'
        }),
    },

    methods: {
        ...mapActions({
            fetchStores: 'store/fetch',
            setShowLoading: 'loadingComponent/setShowLoading',
            changeCurrentUserSetupStatus: 'user/changeCurrentUserSetupStatus',
            testConversion: 'store/testConversion',
        }),
        prev() {
            this.setShowLoading()

            this.changeCurrentUserSetupStatus(UserSetupStatus.ACCEPT_AGREEMENT).then(() => {
                this.setShowLoading(false)
            })
        },
        nxt() {
            this.setShowLoading()

            this.changeCurrentUserSetupStatus(UserSetupStatus.CHARGE_ACCOUNT).then(() => {
                this.setShowLoading(false)
            })
        }
    }
}
</script>